export const studyDe = {
  common: {
    academy: 'Akademie',
    brand: 'Deenly Akademie',
    studyRoom: 'Lernraum',
    collection: 'Sammlung',
    map: 'Karte',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    add: 'Hinzufügen',
    close: 'Schließen',
    search: 'Suchen…',
    all: 'Alle',
    loading: 'Wird geladen…',
    rename: 'Umbenennen',
    name: 'Name',
    edit: 'Bearbeiten',
    write: 'Schreiben',
    fromCollection: 'Aus der Sammlung',
    onMap: 'Auf die Karte',
    email: 'E-Mail',
    password: 'Passwort',
    cards: '{n} Karteikarte | {n} Karteikarten',
    pages: '{n} Seite | {n} Seiten',
    color: 'Farbe {name}',
    colorColon: 'Farbe: {name}',
    colors: { teal: 'Petrol', gold: 'Gold', rose: 'Rosa', sky: 'Himmelblau', violet: 'Violett', slate: 'Schiefergrau', mint: 'Mint', lilac: 'Flieder', white: 'Weiß' },
  },
  errors: {
    network: 'Keine Verbindung zum Server. Prüfe dein Internet und versuche es noch einmal.',
    tooMany: 'Zu viele Versuche. Warte eine Minute und versuche es dann noch einmal.',
    generic: 'Etwas ist schiefgelaufen. Versuche es noch einmal.',
  },
  cardTypes: {
    quran: { label: 'Koran', short: 'Vers' },
    hadith: { label: 'Sunna', short: 'Hadith' },
    scholar: { label: 'Gelehrte', short: 'Zitat' },
    root: { label: 'Wurzeln', short: 'Wurzel' },
    note: { label: 'Meine', short: 'Notiz' },
  },
  templates: {
    fiqh: {
      label: 'Fiqh-Frage',
      hint: 'Wie lautet das Urteil zu etwas: Belege aus Koran und Sunna, die Meinungen der Gelehrten, dein Fazit.',
      lanes: { question: 'Frage', quran: 'Koran', sunnah: 'Sunna', opinions: 'Meinungen der Gelehrten', conclusion: 'Fazit' },
    },
    tafsir: {
      label: 'Tafsir eines Verses',
      hint: 'Ein Vers oder Abschnitt: die Wörter, der Offenbarungsanlass, was die Tafsir-Gelehrten sagen, Lehren.',
      lanes: { ayah: 'Vers', words: 'Wörter und Wurzeln', occasion: 'Offenbarungsanlass', tafsirs: 'Tafsire', lessons: 'Lehren' },
    },
    hadith: {
      label: 'Hadith-Studie',
      hint: 'Ein Hadith: Text und Quelle, Scharh, die Urteile, die sich daraus ergeben, Lehren.',
      lanes: { text: 'Text und Quelle', sharh: 'Scharh', rulings: 'Urteile aus dem Hadith', lessons: 'Lehren' },
    },
    free: {
      label: 'Freie Karte',
      hint: 'Eine leere Karte ohne Rahmen, für alles andere.',
    },
  },
  taskColumns: { todo: 'Zu erledigen', doing: 'In Arbeit', done: 'Erledigt' },
  card: {
    page: 'S. {page}',
    noteLine: 'Notiz: {note}',
  },
  due: {
    late: '{n} T. überfällig',
    today: 'heute',
    tomorrow: 'morgen',
    in: 'in {n} T.',
  },
  password: {
    length: 'Mindestens {n} Zeichen',
    letters: 'Buchstaben',
    numbers: 'Zahlen',
    match: 'Beide Passwörter stimmen überein',
    failed: 'Etwas ist schiefgelaufen. Versuche es erneut.',
    offline: 'Keine Verbindung zum Server. Prüfe dein Internet und versuche es erneut.',
    tooMany: 'Zu viele Versuche. Warte eine Minute und versuche es erneut.',
    meter: 'Passwortstärke',
    show: 'Passwort anzeigen',
    hide: 'Passwort verbergen',
    caps: 'Die Feststelltaste ist aktiv',
    privacy: 'Datenschutz',
    strength: ['Zu schwach', 'Schwach', 'Solide', 'Stark', 'Ausgezeichnet'],
  },
  auth: {
    panelBadge: 'Deenly Panel',
    backToSite: 'Zur Website',
    login: {
      metaTitleAcademy: 'Anmelden · Deenly Akademie',
      metaDescAcademy: 'Melde dich an und lerne weiter an der Deenly Akademie.',
      metaTitle: 'Anmelden · Deenly',
      metaDesc: 'Anmeldung im Deenly Panel.',
      academy: {
        title: 'Willkommen zurück.',
        accent: 'Mach da weiter, wo du aufgehört hast.',
        lead: 'Deine Themen, Quellen und deine Lektüre warten auf dich.',
        cardTitle: 'Anmeldung an der Akademie',
      },
      panel: {
        title: 'Willkommen zurück.',
        accent: 'Bearbeiten. Veröffentlichen. Verfolgen.',
        lead: 'Deenlys Bibliothek, Vorträge, Feed und Analysen, alles an einem Ort.',
        cardTitle: 'Anmeldung im Panel',
      },
      locked: 'Zu viele falsche Versuche. Aus Sicherheitsgründen ist die Anmeldung pausiert. Versuche es in {time} noch einmal.',
      errors: {
        credentials: 'E-Mail oder Passwort stimmen nicht.',
        invalid: 'Gib eine gültige E-Mail-Adresse und dein Passwort ein.',
        network: 'Keine Verbindung zum Server. Prüfe dein Internet und versuche es noch einmal.',
        server: 'Die Anmeldung funktioniert gerade nicht. Versuche es in einer Minute noch einmal.',
      },
      notices: {
        reset: 'Dein Passwort wurde geändert. Melde dich mit dem neuen Passwort an.',
        expired: 'Deine Sitzung ist abgelaufen. Melde dich noch einmal an.',
      },
      noAccount: 'Noch kein Konto?',
      createFree: 'Erstelle kostenlos eins',
      teamOnly: 'Zugang haben nur Teammitglieder. Das Konto richtet ein Administrator ein.',
      forgot: 'Passwort vergessen?',
      retryIn: 'Noch einmal in {time}',
      submit: 'Anmelden',
    },
    forgot: {
      metaTitle: 'Passwort vergessen · Deenly',
      metaDesc: 'Ein Link für ein neues Passwort an deine E-Mail.',
      invalidEmail: 'Gib eine gültige E-Mail-Adresse ein.',
      title: 'Passwort vergessen?',
      accent: 'In einer Minute ein neues.',
      lead: 'Gib die E-Mail deines Kontos ein, und wir schicken dir einen Link für ein neues Passwort. Der Link gilt 60 Minuten.',
      cardSent: 'Sieh in deine E-Mails',
      cardLink: 'Link für ein neues Passwort',
      sentBody: 'Falls es ein Konto mit der Adresse {email} gibt, haben wir gerade einen Link für ein neues Passwort geschickt. Der Link gilt 60 Minuten und funktioniert nur einmal.',
      sentHint: 'Nicht angekommen? Sieh auch im Spam nach oder fordere in einer Minute einen neuen an.',
      resend: 'Noch einmal senden',
      backToLogin: 'Zurück zur Anmeldung',
      send: 'Link senden',
      remembered: 'Es ist mir wieder eingefallen, zurück zur Anmeldung',
    },
    reset: {
      metaTitle: 'Neues Passwort · Deenly',
      metaDesc: 'Lege ein neues Passwort für Deenly fest.',
      title: 'Neues Passwort.',
      accent: 'Ein Schritt.',
      lead: 'Nach der Änderung wirst du auf allen Geräten abgemeldet, auf denen du angemeldet bist.',
      cardBroken: 'Der Link ist nicht vollständig',
      cardSet: 'Lege ein neues Passwort fest',
      hintBroken: 'Öffne den ganzen Link aus der E-Mail noch einmal oder fordere einen neuen an.',
      hintAccount: 'Für das Konto {email}',
      requestLink: 'Neuen Link anfordern',
      newPassword: 'Neues Passwort',
      repeat: 'Neues Passwort wiederholen',
      mismatch: 'Die Passwörter stimmen nicht überein.',
      submit: 'Neues Passwort speichern',
    },
  },
  signup: {
    metaTitle: 'Neues Konto · Deenly Akademie',
    metaDesc: 'Ein kostenloses Konto für die Deenly Akademie: dein Ort, um den Islam zu studieren.',
    title: 'Dein Ort,',
    accent: 'um den Islam zu studieren.',
    lead: 'Verse, Hadithe und Notizen auf einer Karte, deine Khatma und die Bücher, die du liest, deine Pflichten an der Uni. Kostenlos.',
    cardTitle: 'Neues Konto',
    bullet1: 'Eine Karte des Wissens: Verse, Hadithe, Tafsir und Notizen an einem Ort',
    bullet2: 'Belege aus Koran und Hadith, nach Bedeutung gefunden',
    bullet3: 'Khatma, Bücher und Pflichten mit Fristen, jeden Tag vor dir',
    haveAccount: 'Du hast schon ein Konto?',
    signIn: 'Anmelden',
    firstName: 'Vorname',
    lastName: 'Nachname',
    enterFirstName: 'Gib deinen Vornamen ein.',
    enterLastName: 'Gib deinen Nachnamen ein.',
    repeatPassword: 'Passwort wiederholen',
    mismatch: 'Die Passwörter stimmen nicht überein.',
    accept: 'Ich akzeptiere die {policy}.',
    policy: 'Datenschutzerklärung',
    confirmTerms: 'Bestätige, dass du die Datenschutzerklärung akzeptierst.',
    submit: 'Konto erstellen',
  },
  layout: {
    closeMenu: 'Menü schließen',
    today: 'Heute',
    spaces: 'Bereiche',
    newSpace: 'Neuer Bereich',
    spacesFailed: 'Die Bereiche wurden nicht geladen.',
    logout: 'Abmelden',
    dialogSubtitle: 'Ein Fach an der Uni oder ein persönliches Ziel: Darin liegen deine Themen, Aufgaben und deine Lektüre.',
    subject: 'Fach',
    goal: 'Ziel',
    placeholderGoal: 'z. B. Ramadan 1448',
    placeholderSubject: 'z. B. Usul al-Fiqh III',
    create: 'Bereich erstellen',
    ideas: {
      usul: 'Usul al-Fiqh',
      tafsir: 'Tafsir',
      hadith: 'Hadith',
      arabic: 'Arabisch',
      ramadan: 'Ramadan',
      khatma: 'Khatma',
      hifz: 'Hifz',
      exam: 'Prüfung',
    },
  },
  today: {
    metaTitle: 'Heute · Lernraum · Deenly Akademie',
    metaDesc: 'Deine Aufgaben, deine Lektüre und deine Themen.',
    morning: 'Guten Morgen',
    day: 'Guten Tag',
    evening: 'Guten Abend',
    promptFiqh: 'Die Frage, der du nachgehst (z. B. „Sind Zinsen haram?“)',
    failed: 'Wir konnten deinen Lernraum nicht laden.',
    retry: 'Noch einmal versuchen',
    weekTasks: 'Aufgaben dieser Woche',
    allTasks: 'Alle Aufgaben',
    noTasks: 'Keine Aufgaben mit Frist in den nächsten sieben Tagen.',
    doneAria: 'Erledigt: {title}',
    inProgress: 'In Arbeit',
    reading: 'Lektüre',
    planTitle: 'Leg einen Leseplan an',
    planBody: 'Eine Khatma bis zum Ende des Ramadan oder ein Buch für eine Prüfung: Du bekommst ein Tagespensum.',
    addReading: 'Lektüre hinzufügen',
    continue: 'Mach da weiter, wo du aufgehört hast',
    firstTopic: 'Beginne dein erstes Thema',
    streak: 'Lesetage in Folge',
    days: 'Tag | Tage',
    weekAria: 'Diese Woche: {n} Seite | Diese Woche: {n} Seiten',
    weekPages: '{n} Seite diese Woche | {n} Seiten diese Woche',
    saveTip: 'Einen Vers speicherst du auch beim Koranlesen: mit der Schaltfläche „Speichern“ unter jedem Vers.',
  },
  collection: {
    metaTitle: 'Sammlung · Lernraum · Deenly Akademie',
    metaDesc: 'Deine Verse, Hadithe, Zitate und Notizen.',
    subtitle: 'Alles, was du speicherst, einmal, für so viele Themen, wie du möchtest.',
    newCard: 'Neue Karteikarte',
    noResults: 'Nichts zu dieser Suche.',
    empty: 'Deine Sammlung ist leer.',
    emptyBody: 'Speichere deinen ersten Vers, Hadith oder ein Zitat aus einem Buch. Jede Karteikarte trägt ihre Quelle, damit du sie später zitieren kannst.',
  },
  space: {
    fallback: 'Bereich',
    namePrompt: 'Name des Bereichs',
    confirmDelete: 'Den Bereich „{title}“ mit allen Themen, Aufgaben und der Lektüre löschen? Die Karteikarten bleiben in der Sammlung.',
    confirmDeleteTask: 'Aufgabe löschen?',
    deleteSpace: 'Bereich löschen',
    navAria: 'Bereich',
    topics: 'Themen',
    tasks: 'Aufgaben',
    reading: 'Lektüre',
    newTopic: 'Neues Thema',
    taskPlaceholder: 'Neue Aufgabe, z. B. „Prüfung in Usul“',
    deadline: 'Frist',
    moveLeft: 'Nach links: {title}',
    moveRight: 'Nach rechts: {title}',
    khatmaPlan: 'Khatma-Plan',
    book: 'Buch',
    readingEmpty: 'Füge eine Khatma oder ein Buch hinzu, das du liest. Legst du ein Enddatum fest, bekommst du ein Tagespensum.',
    fiqhLabel: 'Die Frage, der du nachgehst',
    topicName: 'Name des Themas',
    placeholderFiqh: 'z. B. Sind Zinsen haram?',
    placeholderTafsir: 'z. B. Ayat al-Kursi (2:255)',
    placeholderHadith: 'z. B. Der Hadith über die Absichten',
    previewFrames: 'Die Karte beginnt mit diesen Rahmen',
    previewEmpty: 'Leere Karte',
    openMap: 'Karte öffnen',
    task: 'Aufgabe',
    status: 'Status',
    topic: 'Thema',
    noTopic: 'Kein Thema',
    notes: 'Notizen',
    openTopic: 'Thema öffnen',
    bookPlaceholder: 'z. B. Ihya Ulum ad-Din, Band 1',
    khatma: 'Khatma',
    author: 'Autor',
    pageCount: 'Seitenzahl',
    khatmaInfo: 'Die Khatma zählt nach den 604 Seiten des Mushaf von Medina; du siehst auch, in welchem Juz du bist.',
    finishBy: 'Ich möchte fertig sein bis',
    optional: '(optional)',
    finishHint: 'Mit einem Datum bekommst du ein Tagespensum: wie viele Seiten pro Tag, damit du rechtzeitig fertig wirst.',
  },
  reading: {
    confirmDelete: '„{title}“ löschen?',
    khatmaJuz: 'Khatma · Juz {juz}',
    until: 'bis {date}',
    finished: 'Geschafft. Möge es gesegnet sein!',
    measureMet: 'Das heutige Pensum ist geschafft ({n} S.).',
    todayOf: 'Heute: {read} von {target} Seite. | Heute: {read} von {target} Seiten.',
    readToday: 'Heute gelesen: {n} S.',
    reachedPage: 'Ich bin bis zu dieser Seite gekommen',
    pagePlaceholder: 'Seite (jetzt {n})',
    plusPages: '+{n} S.',
  },
  picker: {
    title: 'Aus deiner Sammlung',
    subtitle: 'Klicke auf eine Karteikarte, um sie auf die Karte zu legen.',
    empty: 'Hier sind keine Karteikarten. Füge eine Quelle direkt auf der Karte hinzu.',
    onMap: 'Auf der Karte',
  },
  save: {
    label: 'Im Lernraum speichern',
    saved: 'In der Sammlung gespeichert',
  },
  form: {
    confirmDelete: 'Karteikarte aus der Sammlung löschen? Sie verschwindet auch aus allen Themen, in denen sie liegt.',
    editTitle: 'Karteikarte bearbeiten',
    addTitle: 'Quelle hinzufügen',
    intoFrame: 'In den Rahmen „{frame}“',
    toMapAndCollection: 'Auf die Karte und in deine Sammlung',
    toCollection: 'In deine Sammlung',
    kindAria: 'Art der Quelle',
    findSurah: 'Sure finden',
    surahPlaceholder: 'Sure: Name oder Nummer',
    surahs: 'Suren',
    ayahCount: '{n} Vers | {n} Verse',
    noSurah: 'Keine solche Sure.',
    surah: 'Sure',
    perCard: 'höchstens 20 pro Karteikarte',
    from: 'Von',
    to: 'Bis',
    loadingAyat: 'Verse werden geladen…',
    searchHadiths: 'Hadithe suchen',
    hadithPlaceholder: 'Deenlys Sammlung durchsuchen: Absichten, intention, riba…',
    hadithNote: 'Die Sammlung ist vorerst größtenteils auf Englisch. Du findest den Hadith nicht? {link}.',
    hadithManual: 'Gib ihn mit Quelle ein',
    searching: 'Suche läuft…',
    english: 'Englisch',
    noResults: 'Keine Ergebnisse.',
    minLetters: 'Gib mindestens drei Buchstaben ein.',
    backToSearch: '← Zurück zur Suche',
    hadithText: 'Text des Hadith…',
    scholarText: 'Ein Zitat oder eine Zusammenfassung dessen, was der Gelehrte gesagt hat…',
    noteText: 'Deine Notiz…',
    hadithSource: 'Quelle: Sammlung und Nummer',
    scholarSource: 'Werk und Autor',
    hadithSourcePlaceholder: 'z. B. Muslim, 1598',
    scholarSourcePlaceholder: 'z. B. Ibn Qudama, Al-Mughni',
    page: 'Seite',
    titleOptional: 'Titel (optional)',
    addNote: 'Füge der Quelle deine eigene Notiz hinzu',
    myNote: 'Meine Notiz',
    notePlaceholder: 'Wofür das ein Beleg ist, was dir wichtig ist…',
    addToMap: 'Auf die Karte legen',
    saveToCollection: 'In der Sammlung speichern',
    deleteFromCollection: 'Aus der Sammlung löschen',
  },
  node: {
    notePlaceholder: 'Schreiben…',
    noteEmpty: 'Doppelklick zum Schreiben',
    duplicate: 'Duplizieren',
    textPlaceholder: 'Titel…',
    textEmpty: 'Doppelklick für Text',
    tidyLabel: 'Karteikarten ordnen',
    tidy: 'Ordnen',
    deleteFrame: 'Rahmen löschen',
    frame: 'Rahmen',
    addInto: 'Hinzufügen zu: {title}',
    open: 'Öffnen',
    removeFromMap: 'Von der Karte nehmen',
  },
  quick: {
    addToMap: 'Auf die Karte legen',
    placeholder: 'Vers, Wurzel oder Thema…',
    hint: 'Z. B. 2:255 · al-baqara 255-257 · yasin 1 · رحم · Geduld',
    rootTitle: 'Wurzel {root}',
    rootText: 'Die Wörter aus dieser Wurzel und wie oft sie im Koran vorkommen.',
    surah: 'Sure {n}',
    evidence: 'Belege finden',
    evidenceHint: 'Lege die 3 nächsten Verse und 3 Hadithe auf die Karte, jeden in seinen Rahmen.',
    noResults: 'Nichts dazu. Probiere eine Angabe (2:255) oder ein anderes Wort.',
    enter: 'Enter: auf die Karte',
  },
  explorer: {
    title: 'Erkunden',
    tabs: {
      words: 'Wörter',
      tafsir: 'Tafsir',
      translations: 'Übersetzungen',
      related: 'Verse',
      hadiths: 'Hadithe',
      sharh: 'Scharh',
      lessons: 'Lehren',
      ayat: 'Verse',
    },
    surah: 'Sure {n}',
    tafsirName: 'Tafsir Al-Mukhtasar',
    tafsirTitle: 'Tafsir Al-Mukhtasar · {ref}',
    tafsirSource: 'Tafsir Al-Mukhtasar, {ref}',
    translationTitle: 'Übersetzung: {name}',
    translationSource: 'Koran, {ref}, Übersetzung: {name}',
    sharhTitle: 'Scharh: {title}',
    sharhSource: 'HadeethEnc.com, Erklärung des Hadith',
    lessonTitle: 'Eine Lehre aus dem Hadith',
    lessonsTitle: 'Lehren aus dem Hadith',
    edge: {
      tafsir: 'Tafsir',
      translation: 'Übersetzung',
      root: 'Wurzel',
      rootOf: 'Wurzel {root}',
      hadith: 'Hadith',
      sharh: 'Scharh',
      lesson: 'Lehre',
      lessons: 'Lehren',
      related: 'verwandter Vers',
      ayah: 'Vers',
    },
    backToAyah: 'Zurück zum Vers',
    hadithFallback: 'Hadith',
    whatToExplore: 'Was du erkunden kannst',
    failed: 'Das wurde nicht geladen. Versuche es noch einmal.',
    wordsHint: 'Tippe auf ein Wort, um seine Wurzel im ganzen Koran zu sehen.',
    noTafsir: 'Zu diesem Vers gibt es noch keinen Tafsir.',
    relatedHint: 'Die Verse, die in der Bedeutung am nächsten sind. Zieh sie auf die Karte.',
    noRelated: 'Zu diesem Vers gibt es keine verwandten Verse.',
    hadithsHint: 'Die Hadithe, die diesem Vers in der Bedeutung am nächsten sind. Zieh sie auf die Karte.',
    noHadiths: 'Zu diesem Vers gibt es keine Hadithe.',
    explanation: 'Erklärung des Hadith',
    noExplanation: 'Zu diesem Hadith gibt es keine Erklärung.',
    allLessons: 'Alle Lehren als eine Notiz',
    noLessons: 'Zu diesem Hadith gibt es keine Lehren.',
    ayatHint: 'Die Verse, die diesem Hadith in der Bedeutung am nächsten sind.',
    noAyat: 'Keine verwandten Verse.',
    rootOnMap: 'Wurzel auf die Karte',
    rootStats: '{times} in {ayahs}, in {surahs}',
    rootTimes: '{n}-mal | {n}-mal',
    rootAyahs: '{n} Vers | {n} Versen',
    rootSurahs: '{n} Sure | {n} Suren',
    previous: 'Zurück',
    next: 'Weiter',
  },
  topic: {
    fallback: 'Thema',
    newFrame: 'Neuer Rahmen',
    added: 'Zur Karte und zu deiner Sammlung hinzugefügt.',
    removedCount: 'Gelöscht: {n}.',
    cardRemoved: 'Die Karteikarte wurde von der Karte genommen (sie bleibt in der Sammlung).',
    removed: 'Gelöscht.',
    confirmDelete: 'Das Thema und seine Karte löschen? Die Karteikarten bleiben in der Sammlung.',
    restOfMap: 'Sonst noch auf der Karte',
    copied: 'Kopiert. Füge es in Word oder Google Docs ein.',
    tools: {
      search: 'Finden und hinzufügen',
      note: 'Notiz',
      text: 'Text',
      frame: 'Rahmen',
      ayah: 'Vers',
      hadith: 'Hadith',
      quote: 'Zitat eines Gelehrten',
    },
    addHere: 'Hier hinzufügen',
    edgePlaceholder: 'z. B. belegt, erklärt',
    deleteArrow: 'Pfeil löschen',
    emptyTitle: 'Deine Karte ist bereit.',
    tipSearch: 'Drücke / und gib einen Vers (2:255, al-baqara 255), eine Wurzel oder ein Thema ein.',
    tipExplore: 'Wähle einen Vers auf der Karte aus: Wörter, Tafsir, Übersetzungen und verwandte Verse öffnen sich.',
    tipPlus: 'Klicke im Rahmen auf ＋, um genau dort einen Vers, Hadith oder ein Zitat hinzuzufügen.',
    tipDouble: 'Doppelklicke irgendwo auf die Karte für eine Notiz, Text oder einen neuen Rahmen.',
    tipArrow: 'Zieh vom Punkt am Rand einer Karteikarte zu einer anderen: So entsteht ein Pfeil.',
    copyAsText: 'Als Text kopieren',
    emptyDoc: 'Die Karte ist noch leer.',
    back: 'Zurück',
    document: 'Dokument',
    presentTitle: 'Rahmen als Folien präsentieren',
    present: 'Präsentieren',
    deleteTopic: 'Thema löschen',
    toolsAria: 'Werkzeuge',
    zoomOut: 'Verkleinern',
    zoomIn: 'Vergrößern',
    fitAll: 'Alles anzeigen',
    zoomHint: 'Doppelklick: hinzufügen · Shift + ziehen: mehrere markieren · Entf: löschen',
    presentationAria: 'Präsentation',
    prevFrame: 'Vorheriger Rahmen',
    nextFrame: 'Nächster Rahmen',
    finish: 'Beenden',
    undo: 'Rückgängig',
    myNote: 'Meine Notiz',
    wordByWord: 'Wort für Wort',
    tafsir: 'Tafsir',
    link: 'Link',
  },
};
